function notificationTimestamp(notification) {
  const timestamp = Date.parse(notification?.createdAt || notification?.created_at || '');
  return Number.isFinite(timestamp) ? timestamp : 0;
}

export function sortNotificationsOldestFirst(notifications) {
  return notifications
    .map((notification, index) => ({ notification, index }))
    .sort((left, right) => {
      const timeOrder = notificationTimestamp(left.notification) - notificationTimestamp(right.notification);
      return timeOrder || left.index - right.index;
    })
    .map(({ notification }) => notification);
}

export function isTransferRevealNotification(notification, activeLeagueSlug) {
  const status = notification?.data?.status;

  return notification?.type === 'transfer'
    && Boolean(notification?._id)
    && Boolean(notification?.data?.card?.wyId)
    && ['auction_won', 'completed'].includes(status)
    && Boolean(activeLeagueSlug)
    && notification?.leagueSlug === activeLeagueSlug
    && notification?.read !== true;
}
